import {getFiveYears} from 'src/utils'

const getOptions = <T>(p: readonly TOption<T>[]) => p

export const years = getOptions(getFiveYears(new Date().getFullYear()))
